<template>
	<nav class="site-nav site-nav--agent">
	<div class="site-nav-admin__overlay" ref="overlayNavigation" @click="closeDropdown"></div>
		<ul class="site-nav__list">
			<li class="site-nav__item"
				ref="nav-item"
				v-for="item in menuItems"
				:key="item.id"
				:class="[checkForSub(item) ? 'has-sub-menu' : '', isActive(item) ? 'active-link' : '']"
				@click="closeMenu"
			>
				<SvgIcon
					class="site-nav__item-icon"
					:iconName="item.iconMenuItem"
				/>
				<a v-if="item.url.includes('#')"  class="site-nav__link" :href="item.url">
					<SvgIcon
						v-if="checkForSub(item)"
						class="site-nav__icon"
						iconName="ico-arrow-down"
					/>
					{{ item.label }}
				</a>
				<router-link v-else class="site-nav__link" ref="nav-link" :to=item.url>{{ item.label }}</router-link>

				<SvgIcon
					v-if="checkForSub(item)"
					class="site-nav__icon js-nav-icon"
					iconName="ico-arrow-down"
					:onClick="toggleSubMenu"
				/>

				<MainNavigationSub
					v-if="checkForSub(item)"
					:subItems="item.childItems"
					:depth="1"
					:checkForSub="checkForSub"
					:toggleSubMenu="toggleSubMenu"
				/>
			</li>
		</ul>
		<ul class="site-nav__list-user" v-if="!hideUserItems">
			<template v-if="loggedIn">
				<!-- Admin link -->
				<li class="site-nav__item site-nav__item--dropdown" @click="toggle" v-on-click-outside="closeDropdown">
					<a class="site-nav__link" ref="nav-link" href="javascript:;">
						<transition name="fade-in">
							<img v-if="user.photo" :src="user.photo" alt="Login image" class="site-nav-admin__img">
							<img v-else src="@/assets/images/__demo/profile/profile-placeholder.jpg" alt="Login image" class="site-nav-admin__img">
						</transition>
						<a class="site-nav__link user-name" v-if="!hideUserItems">
							Welcome, {{ user.first_name }} {{ user.last_name }}
						</a>
						<SvgIcon
							class="ico-angle-down"
							iconName="ico-angle-down"
							:class="{'chevron-active' : agentLinksData.isOpened, 'chevron-inactive' : !agentLinksData.isOpened}"
						/>
					</a>
						<!-- Links from state -->
						<MainNavigationLinks
							:data="agentLinksData"
						/>
				</li>
			</template>

			<!-- Login link -->
			<li class="site-nav__item" v-else>
				<SvgIcon
					class="site-nav__item-icon"
					iconName="ico-admin"
				/>
				<router-link class="site-nav__link" ref="nav-link" to="/login">
					Login
				</router-link>
			</li>
		</ul>
	</nav>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import MainNavigationSub from './MainNavigationSub';
import { domQueryAll, slideToggle } from '@/config/util';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import MainNavigationLinks from '@/components/main/MainNavigation/MainNavigationLinks';

export default {
	components: {
		MainNavigationLinks,
		SvgIcon,
		MainNavigationSub
	},

	data () {
		return {
			agentLinksData: {
				links: [],
				isOpened: false
			},
			innerWidth: 0,
			hideUserItems: false
		};
	},
	mixins: [onClickOutside],
	computed: {
		menuItems() {
			return this.$store.getters.getMenuItems;
		},
		agentItems() {
			return this.$store.getters.getAgentItems;
		},
		adminItems() {
			return this.$store.getters.getAdminItems;
		},
		superItems() {
			return this.$store.getters.getSuperItems;
		},
		loggedIn() {
			return this.$store.getters.getLoggedIn;
		},
		user() {
			return this.$store.getters.getUser;
		}
	},
	mounted() {
		if (this.user.role === 'admin') {
			this.agentLinksData.links = this.adminItems;
		} else if (this.user.role === 'super_admin') {
			this.agentLinksData.links = this.superItems;
		} else {
			this.agentLinksData.links = this.agentItems;
		}
	},
	methods: {
		closeDropdown() {
			if (this.agentLinksData.isOpened === true) {
				this.agentLinksData.isOpened = false;
				if (this.$refs.overlayNavigation) {
					this.$refs.overlayNavigation.classList.remove('showOverlay');
				}
			}
		},
		toggle() {
			this.agentLinksData.isOpened = !this.agentLinksData.isOpened;
			if (this.agentLinksData.isOpened === true) {
				if (this.$refs.overlayNavigation) {
					this.$refs.overlayNavigation.classList.add('showOverlay');
				}
			} else {
				if (this.$refs.overlayNavigation) {
					this.$refs.overlayNavigation.classList.remove('showOverlay');
				}
			}
		},
		closeMenu() {
			this.$emit('linkIsClicked');
		},
		checkForSub (item) {
			return item?.childItems?.length > 0;
		},
		toggleSubMenu (e) {
			const classActive = 'is-active';
			const slNavIcon = '.js-nav-icon';
			const slSubNav = '.js-subnav';

			const icon = e.target.closest(slNavIcon);
			const ul = icon.parentNode.querySelector(slSubNav);

			if (!icon.classList.contains(classActive)) {
				icon.classList.add(classActive);
				slideToggle.slideDown(ul);
			} else {
				icon.classList.remove(classActive);
				slideToggle.slideUp(ul);
				domQueryAll(slSubNav, ul, el => {
					el.parentNode.querySelector(slNavIcon).classList.remove(classActive);
					slideToggle.slideUp(el);
				});
			}
		},
		isActive(item) {
			if (this.$route.path.indexOf(item.url) > -1) {
				return true;
			}
		},
		handleResize () {
			this.innerWidth = window.innerWidth;
		}
	},
	watch: {
		innerWidth (newWidth) {
			this.hideUserItems = newWidth < 1200;
		}
	},
	beforeMount() {
		window.addEventListener('resize', this.handleResize);
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
	}
};
</script>

<style lang="scss" scoped>
.ico-angle-down {
    padding-right: 6px;
	color: $shuttle-gray;
	transition: $dur $ease;
	font-size: 12px;
    padding-left: 11px;
}

.site-nav-admin__overlay {
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	width: 100%;
	height: 100vh;
	z-index: 1;
	background-color: transparent;
	transition: $dur $ease;
	display: none;

	&.showOverlay {
		display: block;
	}
}

a {
	text-decoration: none;
}

.site-nav {
	line-height: 2;
	height: 100%;
	display: flex;
	justify-content: space-between;
	width: 100%;

	@include mq($xl) {
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		text-align: left;
		height: auto;
	}
}

.site-nav__list {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	transition: $dur $ease;

	@include mq($xl) {
		display: block;
		width: 100%;
	}

	.site-nav__item {
		&.active-link {
			background-color: $link-water;
			border-radius: 14px;

			@include mq($xl) {
				padding: 25px 20px;
				padding-left: 30px;
				border-radius: 0;
			}

			.site-nav__link {
				color: $madison;
			}

			.site-nav__item-icon {
				/deep/
				.svg {
					color: $madison;
					fill: $madison;
				}
			}
		}
	}
}

.site-nav__list-user {
	@include mq($xl) {
		width: 100%;
	}

	.site-nav__item {
		padding: 14px 16px;
		//transition: $dur $ease;
		display: flex;

		@include mq($xl) {
			width: 100%;
			padding: 20px 0 20px 30px;
		}

		&::after {
			display: none;
		}

		&:first-of-type {
			padding: 0 13px;

			@include mq($xl) {
				padding: 20px 0 20px 30px;
				order: 1;
			}

			&::before {
				display: none;
			}

			.site-nav__item-icon {
				font-size: 21px;
				padding-right: 14px;

				@include mq($xl) {
					padding-right: 12px;
					font-size: 18px;
				}
			}
		}

		&:nth-child(2) {
			@include mq($xl) {
				order: 3;

				.site-nav__item-icon {
					padding-right: 0;
					padding-left: 30px;
				}
			}
		}

		&:last-of-type {
			padding-left: 8px;
			margin-left: 22px;
			padding-right: 0;

			@include mq($xl) {
				padding-bottom: 23px;
				padding-left: 0;
				margin-left: 0;
				order: 2;
			}

			.site-nav__link,
			.site-nav__item-icon {
				color: $shuttle-gray;
			}

			@include hover {
				.site-nav__link,
				.site-nav__item-icon {
					color: $dodger-blue;
				}
			}

			.site-nav__item-icon {
				padding-right: 12px;
			}
		}

		.site-nav__link {
			font-family: $font-main;
			font-weight: 600;
			font-size: 14px;
			padding-left: 6px;

			@include mq($xl) {
				font-weight: normal;
				font-size: 16px;
			}
		}
	}
}

.site-nav__item {
	position: relative;
	display: flex;
	position: relative;
    align-items: center;
	transition: $dur $ease;
	margin: 0 15px;
	padding: 14px 16px;
	border-radius: 14px;

	&:nth-child(2) {
		.site-nav__item-icon {
			font-size: 19px;
		}
	}

	@include mq($xl + 1, 'min') {

		&.has-sub-menu {
			padding-right: 20px;
		}
	}

	@include mq($xl) {
		margin: 0;
		padding: 25px 20px;
		border-radius: 0;
		padding-left: 30px;
		border-bottom: 1px solid rgba( #9e9e9e, .3);
		overflow: hidden;
		transition: $dur $ease;
	}

	@include hover {
		cursor: pointer;
		background-color: $link-water;

		.site-nav__link--no-hover {
			color: $shuttle-gray;

			.site-nav__item-icon {
				color: $shuttle-gray;
			}
		}

		.site-nav__item-icon {
			color: $madison;
		}

		/deep/ {
			> .site-subnav__list {
				transform: translateY(0);
				opacity: 1;
				visibility: visible;
			}
		}
	}

	&.site-nav__item--dropdown {
		@include mq($xl) {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			padding-bottom: 0 !important;
			border-bottom: none;
		}

		@include hover {
			background-color: transparent !important;
		}
	}
}

.site-nav__icon {
	color: $white;
	right: 0;
	@include center(y);

	@include mq($xl) {
		z-index: 10;
		cursor: pointer;
		font-size: 20px;
		padding: 5px;
		top: 1px;
		transform: none;
		transition: $dur $ease;

		&.is-active {
			transform: rotate(180deg);
		}
	}
}

.site-nav__link {
	position: relative;
	text-decoration: none;
	font-family: $font-main;
	font-size: 16px;
	font-weight: 600;
	line-height: 1.2;
	color: $shark;
	transition: $dur $ease;
	height: 100%;
    display: flex;
    align-items: center;
	padding: 0;

	&.user-name {
		@include mq($lg) {
			display: none;
		}
	}

	@include mq($xl) {
		color: $fiord;
	}

	&.nuxt-link-active {
		color: $red;
	}
}

.site-na__item-icon {
	svg {
		color: $black;
	}
}

.site-nav-icon {
	display: block;
	color: $black;
	font-size: 14px;
	background-color: $red;
	width: 17px;
	height: 17px;
}

.site-nav__item-icon {
	padding-right: 6px;
	color: $shuttle-gray;
	transition: $dur $ease;
	font-size: 16px;

	@include mq($xl) {
		font-size: 14px;
		padding-right: 12px;
		color: $fiord;
	}
}

/*users link*/
.site-nav__list-user {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	height: 100%;

	@include mq($xl) {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		padding-bottom: 20px;
	}
}

.site-header {
	&.is-sticky {

		.site-nav__list {
			transform: scale(0.99);
			transform-origin: left;
			transition: $dur $ease;

			@include mq($xl) {
				transform: scale(1);
			}
		}
	}
}

//Dropdown
.site-nav-admin__dropdown {
	position: absolute;
	background-color: $white;
	padding: 18px 0;
	top: 88%;
	min-width: 209px;
	width: 100%;
	right: 0;
	box-shadow: 0 0px 7px -2px rgba(0, 0, 0, 0.75);
	z-index: 2000;

	@include mq($xl) {
		position: relative;
		top: auto;
		min-width: auto;
		width: 100%;
		right: auto;
		background-color: #e5e5e5;
		box-shadow: none;
		padding: 0;
	}

	&::before {
		content: '';
		position: absolute;
		right: 22px;
		top: -10px;
		width: 24px;
		height: 24px;
		background-color: $white;
		box-shadow: 0 0px 7px -2px rgba(0, 0, 0, 0.75);
		transform: rotate(45deg);
		z-index: 0;

		@include mq($xl) {
			display: none;
		}
	}
	&::after {
		content: '';
		position: absolute;
		right: 0;
		top: 0;
		width: 55px;
		height: 24px;
		background-color: $white;
		z-index: 0;

		@include mq($xl) {
			display: none;
		}
	}
}

.site-nav-admin__dropdown-link {
	font-family: $font-main;
	font-size: 16px;
	line-height: 1.2;
	color: $shuttle-gray;
	transition: $dur $ease;
	z-index: 1102;
	position: relative;
	display: flex;

	@include mq($xl) {
		font-size: 14px;
		align-items: end;
	}
}

.site-nav-admin__dropdown-icon {
	color: $fiord;
	transition: $dur $ease;
	font-size: 22px;
	padding-right: 9px;

	@include mq($lg) {
		font-size: 17px;
		height: 17px;
	}

	svg {
		height: 20px;

		@include mq($lg) {
			height: 17px;
		}
	}
}

.site-nav-admin__dropdown-item {
	display: flex;
	align-items: center;
	padding: 0 27px 19px;

	@include mq($xl) {
		padding: 10px 20px;
		border-bottom: 1px solid rgba(158, 158, 158, 0.3);

	}

	@include hover {
		.site-nav-admin__dropdown-link,
		.site-nav-admin__dropdown-icon {
			color: $dodger-blue;
		}
	}

	&:last-of-type {
		@include hover {
			.site-nav-admin__dropdown-link,
			.site-nav-admin__dropdown-icon {
				color: $dodger-blue;
			}
		}

		.site-nav-admin__dropdown-link {
			color: $red;
		}

		.site-nav-admin__dropdown-icon {
			color: $orange;
		}
	}

	&:nth-child(2) {
		.site-nav-admin__dropdown-icon {
			font-size: 20px;

			@include mq($lg) {
				font-size: 17px;
			}
		}
	}
}

.site-nav-admin__dropdown-item--logout {
    border-top: 1px solid $grey-light;
    padding-top: 20px;

	@include mq($xl) {
		padding: 23px 20px 23px 60px;
	}
}

.chevron-active {
	transform: rotateX(180deg);
	will-change: transform;
}

.user-mobile {
	display: none;
	font-weight: 500;

	@include mq($md) {
		display: block;
	}
}

.site-nav-admin__img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
	object-fit: cover;

	@include mq($md) {
		width: 30px;
		height: 30px;
	}
}
</style>
